import { FieldTypes } from "../formik-form-components/FormikFormLine/constants";
import { RefObject } from "react";

export const PHONE_NUMBER = "Phone number";
export const CONFIRM = "Confirm";
export const CHECK_EMAIL_FOR_CONFIRMATION_CODE =
  "Check email for confirmation code.";
export const GO_TO_MY_ACCOUNT = "Go to my account";
export const SIGN_IN_MODE = "Log in";
export const PASSKEY_MODE = "Passkey sign in";
export const SIGN_UP_MODE = "Sign Up";
export const CONFIRM_EMAIL_MODE = "Confirm your email address";
export const FORGOT_PASSWORD = "Forgot password";
export const RESET_PASSWORD = "Reset password";
export const SUCCESS = "Success!";
export type AuthMode =
  | typeof PASSKEY_MODE
  | typeof SIGN_IN_MODE
  | typeof SIGN_UP_MODE
  | typeof CONFIRM_EMAIL_MODE
  | typeof FORGOT_PASSWORD
  | typeof RESET_PASSWORD
  | typeof SUCCESS;

export interface AuthInputValue {
  placeholder?: string;
  type: FieldTypes;
  name: string;
  label: string;
  subLabel?: string;
  required?: boolean;
  ref?: RefObject<HTMLInputElement | null>;
}

export const ACTION_QUERY_KEY = "auth-action";
export const ACTION_QUERY_SIGN_UP = "sign-up";

export const THREE_STEP_INFO = [
  {
    iconInfo: {
      path: "/icons/upload.svg",
      alt: "upload and check cad files",
    },
    label: "Upload & Check CAD Files",
  },
  {
    iconInfo: {
      path: "/icons/pencil.svg",
      alt: "edit and save board designs",
    },
    label: "Edit & Save Board Designs",
  },
  {
    iconInfo: {
      path: "/icons/truck.svg",
      alt: "order and track deliveries",
    },
    label: "Order & Track Deliveries",
  },
];
